import './index.styl';
import _ from 'lodash';
import { View } from 'backbone.marionette';
import template from './index.jst';
import { ErrorsModal, Preloader } from '../../../../utils';
import Radio from 'backbone.radio';

const CHANNEL_TRADE = Radio.channel('trade');

export class TradeReversePopup extends View {
	get template() {
		return template;
	}

	get className() {
		return 'modal-reverse-trade-overlay';
	}

	ui() {
		return {
			close: '.js-close',
			rollback: '.js-rollback-team',
			reverse: '.js-reverse-trade',
			choose: '.js-select-trade'
		}
	}

	events() {
		return {
			'click @ui.close': 'onClose',
			'click @ui.rollback': 'onRollbackTeam',
			'click @ui.reverse': 'onReverseTrade',
			'click @ui.choose': 'onChoose',
		}
	}

	initialize() {
		const onError = errors => {
			Preloader.hide();
			ErrorsModal.show(errors);
		};

		this.model.set({ selected_trades: [] }, { silent: true });

		this.listenTo(this.model, 'rollback:team:errors', onError);
		this.listenTo(this.model, 'reverse:trade:errors', onError);
		this.listenTo(this.model, 'change', this.render);
	}

	onClose() {
		this.destroy();
	}

	async onRollbackTeam() {
		Preloader.show();

		const { success, result } = await this.model.rollbackTeam();

		if (success) {
			this.onSucccessChange(result);
		}

		this.onClose();
	}

	async onReverseTrade() {
		Preloader.show();

		const { success, result } = await this.model.reverseTrades({
			trade_ids: this.model.get('selected_trades') || []
		});

		if (success) {
			this.onSucccessChange(result);
		}

		this.onClose();
	}

	onSucccessChange(result) {
		CHANNEL_TRADE.trigger('success:trade', { team: _.first(result) });
	}

	onChoose(event){
		const selected_class = 'is-selected';

		$(event.currentTarget).toggleClass(selected_class);

		const selected_trades = this.ui.choose
			.filter((_, elem) => $(elem).hasClass(selected_class))
			.toArray()
			.map(elem => parseInt(elem.dataset.id, 10));

		this.model.set({ selected_trades });
	}
}

export default TradeReversePopup;